<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-6 col-xs-12 col-lg-6 col-md-8 justify-content-center">
        <div class="application-submmited-card">
          <div class="col-sm-12 col-xs-12 no-padding">
            <img :src="logo" :alt="companyName" />
          </div>
          <i class="fa fa-check-circle"></i>
          <h3>{{ t("application.submitted_title") }}</h3>
          <div v-if="isEnquiry" v-html="t('application.enquiry_submitted')" />
          <div
            v-else
            v-html="t('application.submitted', { company: companyName })"
          />
          <br />
          <a
            v-if="from === 'app'"
            @click="doneHandle"
            class="btn btn-secondary btn-md"
            style="width: 200px"
          >
            {{ t("filter.done") }}
          </a>
          <a v-else href="/" class="btn btn-secondary">
            {{ t("error.go_homepage") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ApplySubmitted",
  inheritAttrs: false,
  props: {
    companyName: {
      type: String,
      default: "",
    },
    companyId: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    from: {
      type: String,
      default: "web",
    },
  },
  computed: {},
  mounted: function () {},
  methods: {
    doneHandle: function (e) {
      if (this.$attrs.application) {
        window.close();
        return;
      }
      window.location.href = "/insurance";
    },
  },
};
</script>
